module.exports = __webpack_public_path__ + "img/status_success.8a97ed9f.png";